module.exports = __webpack_public_path__ + "img/dual-temperature-lg.c5f78abb.svg";